var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZicha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1741596246418,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1657,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M894.149097 132.005286c33.431243 12.33833 54.677745 44.438467 52.885871 78.330477v386.174375c0 270.77771-407.164895 418.172119-424.776453 423.752525L511.916844 1023.948804l-10.341671-3.686141C483.963615 1014.682257 76.79872 867.287848 76.79872 596.458942V210.335763c0-35.735081 20.683342-65.992148 54.063389-78.330477L485.857881 5.550201a68.603163 68.603163 0 0 1 54.063389 0l354.279023 126.455085z m-380.389183 140.636485c-120.977071 0-219.42773 99.935355-219.42773 222.704299 0 122.717748 98.450659 222.704299 219.42773 222.704299 37.066187 0 71.674947-8.703386 101.471247-24.727856l43.721717 44.438467a33.380047 33.380047 0 0 0 48.636571 0 35.018331 35.018331 0 0 0 0-49.967677l-37.066187-37.629348c38.909257-39.472417 61.384472-94.406144 61.384473-154.817885-0.614357-123.383301-99.065016-222.704299-218.147821-222.704299zM362.986544 495.34607c0-83.910884 66.81129-152.974815 148.879104-152.974815 82.016618 0 150.722174 67.835218 150.722174 152.974815 0 83.859688-66.862486 152.974815-150.722174 152.974815A152.667637 152.667637 0 0 1 362.986544 495.34607z",
    fill: "#F6812B",
    "p-id": 1658
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZicha);
export default __webpack_public_path__ + "static/media/zicha.e4ca04cb.svg";
export { ForwardRef as ReactComponent };